module.exports = __webpack_public_path__ + "img/logo-gar.ccf76810.png";